import { Button } from "@material-ui/core";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  const processes_feture = {
    arrows: false,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <main>
      <NewHead />

      <Helmet>
        <title>WazirX clone script development </title>

        <meta name="title" content="WazirX clone script development company" />
        <meta
          name="description"
          content="Beleaf technologies your trustable partner in wazirx clone script development service. Dive into the world of possibilities and start your Wazirx clone script development. Get a free demo from our industry grade experts. Crypto exchange a future of hope for cryptopreneurs."
        />

        <meta property="og:title" content="WazirX clone script development " />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/wazirx-clone-script-development"
        />
      </Helmet>

      <main className="wazirx_main">
        <section className="wazirx_bannersec d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 d-flex align-items-center">
                <div className="wazirx_bannersec_content d-flex flex-column">
                  <h1 className="mb-0">
                    WazirX
                    <br />
                    Clone Script
                    <br />
                    Development Company
                  </h1>
                  <p className="mb-0 wazirx_p text-white">
                    Get into the world of cryptocurrency exchange with our
                    expert services developed to meet your specific business
                    needs.
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="wazirx_button"
                  >
                    Lets Discuss
                  </Button>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="wazirx_bannersec_img">
                  <img
                    src={require("../../image/wazirx/banner_img.webp")}
                    className=""
                    alt="WaziX Clone Script Development"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_whatissec d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9">
                <div className="wazirx_whatissec_content d-flex flex-column align-items-center text-center">
                  <h2 className="wazirx_h2 mb-0">
                    What is Wazirx
                    <br />
                    Clone Script Development?
                  </h2>
                  <p className="mb-0 wazirx_p ">
                    WazirX clone script development is the process of creating a
                    customized and scalable clone of the WazirX crypto exchange
                    platform. It enables entrepreneurs to establish their own
                    peer-to-peer cryptocurrency exchange, enabling secure and
                    seamless transactions. Companies which provide WazirX clone
                    script development should be chosen carefully to minimize
                    the risk. Beleaf Technologies is one of the renowned firms
                    in the industry in providing crypto exchange clone scripts.
                  </p>
                  <a href="https://wa.me/7904323274" className="">
                    <button className="wazirx_button">
                      Talk To Our Experts
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_featuressec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wazirx_featuressec_title text-center">
                  <h2 className="wazirx_h2 mb-2">
                    Features of Our
                    <br />
                    Wazirx Clone Script Development
                  </h2>
                  <p className="wazirx_p mb-0">
                    Better features will gain a better user base it leads to
                    enhanced revenue generation. At beleaf technologies we
                    develop our wazirx clone script with distinctive features.
                  </p>
                </div>
              </div>
            </div>
            <div className="wazirx_featuressec_cardarea mt-5">
              <div className="row">
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/userverification.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">
                      User Authentication and Security
                    </h3>
                    <p className="wazirx_card_p mb-0">
                      Ensure a secure environment for users with two-factor
                      authentication and encrypted data transmission. And anti
                      phishing code.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/wallet.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Integrated Wallets</h3>
                    <p className="wazirx_card_p mb-0">
                      Enable users to manage their cryptocurrency holdings with
                      ease through integrated digital wallets of their choice.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/tradeengine.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Trading Engine</h3>
                    <p className="wazirx_card_p mb-0">
                      {" "}
                      Facilitate fast and efficient trading with a strong and
                      high-performance trading engine which meets your trading
                      requirement seamlessly.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/adminpaner.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Admin Panel</h3>
                    <p className="wazirx_card_p mb-0">
                      Gain control over the platform with a feature-rich admin
                      panel, managing users, transactions, and settings
                      effortlessly.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/liquidity.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Liquidity Management</h3>
                    <p className="wazirx_card_p mb-0">
                      Ensure liquidity on your exchange through efficient
                      management tools. Make your exchange attract more users.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/multicurrency.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Multi-Currency Support</h3>
                    <p className="wazirx_card_p mb-0">
                      {" "}
                      Allow users to trade a variety of cryptocurrencies and
                      trading pairs, expanding your platform's market reach.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_whychoosesec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wazirx_whychoosesec_title text-center">
                  <h2 className="wazirx_h2 mb-2">
                    Why Choose Beleaf Technologies
                    <br />
                    for Wazirx Clone Script Development?
                  </h2>
                  <p className="wazirx_p mb-0">
                    At Beleaf Technologies, we bring expertise and dedication to
                    the table
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="wazirx_whychoosesec_img d-flex justify-content-center">
                  <img
                    src={require("../../image/wazirx/whychoose_img.webp")}
                    className=""
                    alt="WaziX Clone Script Development"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="wazirx_whychoosesec_cardarea mt-5">
                  <div className="row">
                    <div className="col-lg-12 mb-5">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/provenontime.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2">
                            Proven Track Record
                          </h3>
                          <p className="wazirx_card_p mb-0">
                            {" "}
                            Benefit from our experience in developing successful
                            cryptocurrency exchange platforms.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 mb-5">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/customization.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2">Custom Solutions</h3>
                          <p className="wazirx_card_p mb-0">
                            {" "}
                            Receive carefully developed solutions that align
                            with your business goals and requirements.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 mb-5">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/security.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2">Security First</h3>
                          <p className="wazirx_card_p mb-0">
                            We prioritize the security of your platform,
                            implementing industry best practices to safeguard
                            user assets.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 mb-5">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/scalability.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2">Scalability</h3>
                          <p className="wazirx_card_p mb-0">
                            {" "}
                            Our solutions are developed to grow with your
                            business, ensuring long-term success.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12 mb-5">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/24support.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2">24/7 Support</h3>
                          <p className="wazirx_card_p mb-0">
                            {" "}
                            Experience continuous support from our team, ready
                            to assist you at any stage.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="wazirx_whychoosesec_card  align-items-center d-flex">
                        <div className="wazirx_whychoosesec_card_img mr-4">
                          <img
                            src={require("../../image/wazirx/ontimedelivery.webp")}
                            className=""
                            alt="WaziX Clone Script Development"
                          />
                        </div>
                        <div className="wazirx_whychoosesec_card_content d-flex flex-column align-itms-center">
                          <h3 className="wazirx_h3 mb-2"> On time delivery</h3>
                          <p className="wazirx_card_p mb-0">
                            Deployment of your product on time to ensure your
                            exchange starts running at your desired time.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_benefitssec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <div className="wazirx_benefitssec_title text-center">
                  <h2 className="wazirx_h2 mb-2">
                    Benefits of
                    <br />
                    Wazirx Clone Script Development
                  </h2>
                  <p className="wazirx_p mb-0">
                    Wazirx clone script enables you to start your exchange with
                    endless possibilities. We can see the benefits of wazirx
                    clone script here
                  </p>
                </div>
              </div>
            </div>
            <div className="wazirx_benefitssec_cardarea mt-5">
              <Slider {...processes_feture}>
                <div className="slider_section">
                  <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/rapiddeployment.webp")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-2 mb-0">
                          Rapid Deployment
                        </h3>
                        <p className="wazirx_card_p mb-0">
                          Start your cryptocurrency exchange business promptly
                          with our ready-to-deploy Wazirx clone script.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/customization_benefits.webp")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-0">Customization</h3>
                        <p className="wazirx_card_p mb-0">
                          Develop the platform to match your brand identity and
                          unique business requirements. Customize according to
                          your goals.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/security_benefits.webp")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-0">Security</h3>
                        <p className="wazirx_card_p mb-0">
                          Implement strong security features to ensure a secure
                          trading environment for your users. Security measures
                          help to build trust in your users.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider_section">
                  <div className="row justify-content-center">
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/scalability_benefits.webp")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-0"> Scalability</h3>
                        <p className="wazirx_card_p mb-0">
                          Easily scale your platform as your user base expands,
                          ensuring smooth and uninterrupted services.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/cost.png")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-0">Cost-Effective</h3>
                        <p className="wazirx_card_p mb-0">
                          Save on development costs and time by utilizing our
                          pre-built Wazirx clone script. Building a crypto
                          exchange from scratch will be a time consuming
                          process.
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-4 col-sm-6">
                      <div className="wazirx_benefitssec_card d-flex flex-column align-items-center text-center">
                        <img
                          src={require("../../image/wazirx/userinterface_benefits.webp")}
                          className=""
                          alt="WaziX Clone Script Development"
                        />
                        <h3 className="wazirx_h3 mb-0">
                          {" "}
                          User-Friendly Interface
                        </h3>
                        <p className="wazirx_card_p mb-0">
                          Provide a hassle free and attractive experience for
                          your traders, enhancing user engagement. Better UI/UX
                          will attract more users.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </section>
        <section className="wazirx_startyoursec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="wazirx_startyoursec_img d-flex justify-content-center">
                  <img
                    src={require("../../image/wazirx/startyour_img.webp")}
                    className=""
                    alt="WaziX Clone Script Development"
                  />
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center">
                <div className="wazirx_startyoursec_content d-flex flex-column ">
                  <h2 className="wazirx_h2 mb-0">
                    Start Your Wazirx Clone Script Development with Beleaf
                    Technologies
                  </h2>
                  <p className="wazirx_p mb-0">
                    Venture into the cryptocurrency exchange market with Beleaf
                    Technologies. Our Wazirx clone script development services
                    provide a seamless and cost-effective way to establish your
                    presence in the rapidly growing crypto industry. Don't wait
                    for the opportunity. Create your opportunity and start
                    earning from now.
                  </p>
                  <button
                    data-toggle="modal"
                    data-target="#myModal"
                    className="wazirx_button"
                  >
                    Start Today
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_revenuefactorsec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wazirx_featuressec_title text-center">
                  <h2 className="wazirx_h2 mb-2">
                    Revenue Factors of
                    <br />
                    Wazirx Clone Script Development
                  </h2>
                  <p className="wazirx_p mb-0">
                    Generate revenue through our wazirx clone script in no time.
                    Join the community of cryptopreneurs in the meantime.
                  </p>
                </div>
              </div>
            </div>
            <div className="wazirx_featuressec_cardarea mt-5">
              <div className="row justify-content-center">
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/transactioncost.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Transaction Fees</h3>
                    <p className="wazirx_card_p mb-0">
                      Generate revenue by charging a percentage on each trade
                      conducted on your platform. It will give you a significant
                      amount of revenue.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/listingfees.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Listing Fees</h3>
                    <p className="wazirx_card_p mb-0">
                      Offer premium services like listing new tokens for a fee,
                      contributing to your revenue stream. Which also helps in
                      building a community of new cryptopreneurs.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/withdrawcharges.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Withdrawal Charges</h3>
                    <p className="wazirx_card_p mb-0">
                      {" "}
                      Implement minimal withdrawal fees, contributing to overall
                      revenue.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/premium.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Premium Memberships</h3>
                    <p className="wazirx_card_p mb-0">
                      Introduce premium membership plans with added benefits,
                      creating an additional income source.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-6 d-flex">
                  <div className="wazirx_featuressec_card d-flex flex-column">
                    <img
                      src={require("../../image/wazirx/partnership.webp")}
                      className=""
                      alt="WaziX Clone Script Development"
                    />
                    <h3 className="wazirx_h3 mb-0">Strategic Partnerships</h3>
                    <p className="wazirx_card_p mb-0">
                      Collaborate with other businesses and exchanges for mutual
                      benefits, expanding revenue streams.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="wazirx_takeawaysec">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="wazirx_takeawaysec_content text-center d-flex flex-column">
                  <h2 className="wazirx_h2 mb-0">Take Away</h2>
                  <p className="mb-0 wazirx_p ">
                    Join the cryptocurrency surge by launching your own Crypto
                    exchange platform. Beleaf Technologies makes it easy and
                    efficient, ensuring you're well-equipped to thrive in this
                    dynamic market. Choose an experienced wazirx clone script
                    development service provider like beleaf technologies to
                    make sure your exchange generates revenue.
                  </p>
                  <div className="text-center mt-3">
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="wazirx_button"
                    >
                      Lets Discuss
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-white">
          {/* faq */}
          <article className="primary__landing-content-container">
            <div className="landing-faq-wrapper">
              <div className="row">
                <div className="col-lg-6">
                  <h6 className="landing-faq-left-title">
                    Frequently Asked{" "}
                    <span className="faq-span">Questions.</span> {""}
                  </h6>
                </div>
                <div className="col-lg-6">
                  <div>
                    <div className="container">
                      <div className="accordion" id="faq">
                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead1">
                            <button
                              className="landing-faq-title collapsed"
                              type="button"
                              data-toggle="collapse"
                              data-target="#faq1"
                              aria-expanded="true"
                              aria-controls="faq1"
                            >
                              How long does it take to deploy the Wazirx clone
                              script?
                            </button>
                          </div>

                          <div
                            id="faq1"
                            className="collapse"
                            aria-labelledby="faqhead1"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              The deployment time depends on the customization
                              requirements. However, our team strives for quick
                              and efficient launches.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead2">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq2"
                              aria-expanded="true"
                              aria-controls="faq2"
                            >
                              What security measures are in place?
                            </div>
                          </div>

                          <div
                            id="faq2"
                            className="collapse"
                            aria-labelledby="faqhead2"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              We implement robust security features, including
                              two-factor authentication, encryption, and regular
                              security audits.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead3">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq3"
                              aria-expanded="true"
                              aria-controls="faq3"
                            >
                              Can I customize the platform to match my brand?
                            </div>
                          </div>

                          <div
                            id="faq3"
                            className="collapse"
                            aria-labelledby="faqhead3"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Absolutely! Our Wazirx clone script is designed
                              for easy customization to reflect your unique
                              brand identity.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead4">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq4"
                              aria-expanded="true"
                              aria-controls="faq4"
                            >
                              How do you ensure scalability as my business
                              grows?
                            </div>
                          </div>

                          <div
                            id="faq4"
                            className="collapse"
                            aria-labelledby="faqhead4"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              Our solutions are built with scalability in mind,
                              allowing you to expand services and accommodate a
                              growing user base seamlessly.
                            </div>
                          </div>
                        </div>

                        <div className="landing-faq-card">
                          <div className="landing-faq-header" id="faqhead5">
                            <div
                              className="landing-faq-title collapsed"
                              data-toggle="collapse"
                              data-target="#faq5"
                              aria-expanded="true"
                              aria-controls="faq5"
                            >
                              What ongoing support do you provide after
                              deployment?
                            </div>
                          </div>

                          <div
                            id="faq5"
                            className="collapse"
                            aria-labelledby="faqhead5"
                            data-parent="#faq"
                          >
                            <div className="landing-faq-content">
                              We offer 24/7 support to address any issues or
                              questions you may have, ensuring a smooth
                              operation of your exchange.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </section>
      </main>

      <ServiceFooter />
    </main>
  );
}

export default Cex;
